import React from 'react';

import { GPSRaw as GPSRawUI } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const GPSRaw = ({ data: robotId }) => {
  const gpsRaw = useRobotTelemetry(robotId, MESSAGE.GPS_RAW_INT);

  return (
    <GPSRawUI
      latitude={(gpsRaw?.lat ?? 0) / 1e7}
      longitude={(gpsRaw?.lon ?? 0) / 1e7}
      altitude={(gpsRaw?.alt ?? 0) / 1e3}
      satellites={gpsRaw?.satellitesVisible ?? 0}
      eph={gpsRaw?.eph ?? 0}
      epv={gpsRaw?.epv ?? 0}
      showData
    />
  );
};

export default GPSRaw;
